import React, { useState } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import PropTypes from "prop-types";
import PipedriveLogoBubbleComponent from "../../widgets/pipedriveLogoBubble/PipedriveLogoBubbleComponent.jsx";
import ButtonLoaderComponent from "../../widgets/ButtonLoaderComponent.jsx";
import { useToast } from "../../../hooks/useToast.jsx";

const ProductPipedriveButtonComponent = ({ product }) => {
    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);
    const { createProductOnPipedrive } = useStoreActions(actions => actions.orders);
    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false);

    if (product.idPipedrive != null) {
        return (
            <a
                href={`https://metiers360.pipedrive.com/product/${product.idPipedrive}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="d-flex justify-content-center"
            >
                <PipedriveLogoBubbleComponent />
            </a>
        );
    }

    if (!product.isAxonautAvailable || !ACTIONS?.products?.createPipedrive) {
        return <span className="text-muted">—</span>;
    }

    const handleClick = (e) => {
        e.stopPropagation();
        setIsLoading(true);
        createProductOnPipedrive({ uniqueId: product.uniqueId })
            .catch(() => toast.open({ message: "Erreur lors de la création du produit sur PipeDrive", variant: "danger" }))
            .finally(() => setIsLoading(false));
    };

    return (
        <ButtonLoaderComponent
            size="sm"
            variant="outline-secondary"
            msg="Ajouter sur PipeDrive"
            isSending={isLoading}
            disabled={isLoading}
            onClick={handleClick}
        />
    );
};

ProductPipedriveButtonComponent.propTypes = {
    product: PropTypes.object.isRequired,
};

export default ProductPipedriveButtonComponent;
